/* eslint-disable import/no-internal-modules */
import { useAuth0 } from '@auth0/auth0-react';
import { Outlet, useMatch } from 'react-router-dom';

import { routes } from '~/shared/config/routes';
import { auth0Functions } from '~/shared/lib/auth-0';
import { PageLayout } from '~/shared/ui/page-layout';

import { useSaveUser } from '~/features/authorization/login';
import { useSocketForSupportChat } from '~/features/socket/support-chat/lib';

import { SideBarWidget } from '~/widgets/side-bar';
import { TopBarWidget } from '~/widgets/top-bar';

export function RootLayout() {
  const { logout, getAccessTokenSilently } = useAuth0();

  useSocketForSupportChat();
  auth0Functions.logout = logout;
  auth0Functions.getAccessTokenSilently = getAccessTokenSilently;

  // This is a way to bypass auth0 restrictions, since in local development auth0 action do not save the user to the local database
  useSaveUser();

  const isDashboardLayout = useMatch({
    path: routes.dashboard.get(),
    end: false,
  });

  const topBar = <TopBarWidget />;
  const sideBar = isDashboardLayout ? <SideBarWidget /> : null;

  return (
    <PageLayout topBar={topBar} sideBar={sideBar}>
      <Outlet />
    </PageLayout>
  );
}
